import { render, staticRenderFns } from "./OPwaUpdater.vue?vue&type=template&id=24a0c614"
import script from "./OPwaUpdater.vue?vue&type=script&lang=js"
export * from "./OPwaUpdater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports